// "Why this listing was declined", for every place that shows a listing's status outside the
// redesigned listings page (which draws the same note itself: Listings2/views/ListingViews.jsx).
// Partners read the plain wording from Util/statusReason.js. Staff also get the value the hub
// stores and who decided. Keep this file identical in extranet-sh and extranet-vt.
import React from "react";
import { partnerStatusReasonList, declineProvenance } from "../../Util/statusReason";
import "./status-reason-note.css";

const StatusReasonNote = ({ status, xdata, admin = false }) => {
  const reasons = partnerStatusReasonList(status, xdata);
  if (!reasons.length) return null;
  const declined = String(status || "").toLowerCase() === "declined";
  const raw = String(xdata?.declineReason || "").trim();
  const who = declined ? declineProvenance(xdata) : "";
  return (
    <div className={`srn ${declined ? "bad" : "warn"}`} data-testid="status-reason-note">
      <b>{declined ? "Why this listing was declined" : "Why this listing is not live yet"}</b>
      {reasons.length > 1
        ? <ul>{reasons.map((r, i) => <li key={i}>{r}</li>)}</ul>
        : <span>{reasons[0]}</span>}
      {admin && declined && (raw || who) &&
        <em className="srn-raw">Internal: {raw || "no reason stored"}{who ? ` · ${who}` : ""}</em>}
    </div>
  );
};

export default StatusReasonNote;
